__turbopack_context__.v({
  "checkboxGroupHeading": "press-search-module-scss-module__BuSG7q__checkboxGroupHeading",
  "checkboxGroups": "press-search-module-scss-module__BuSG7q__checkboxGroups",
  "filterHeading": "press-search-module-scss-module__BuSG7q__filterHeading",
  "pills": "press-search-module-scss-module__BuSG7q__pills",
  "pressReleasesContainer": "press-search-module-scss-module__BuSG7q__pressReleasesContainer",
  "resultCount": "press-search-module-scss-module__BuSG7q__resultCount",
  "resultsCountSection": "press-search-module-scss-module__BuSG7q__resultsCountSection",
  "sortByTitle": "press-search-module-scss-module__BuSG7q__sortByTitle",
  "sortControl": "press-search-module-scss-module__BuSG7q__sortControl",
});
